module.exports = __webpack_public_path__ + "img/contact-portrait.53bf877.webp";